import {
  DownOutlined,
  EyeOutlined,
  FileAddOutlined,
  ReadOutlined,
  RightOutlined,
} from '@ant-design/icons';

import {
  Badge,
  Button,
  Card,
  Col,
  Divider,
  Empty,
  Grid,
  Input,
  Modal,
  Pagination,
  Row,
  Tooltip,
  Typography,
  notification,
} from 'antd';

import React, { useEffect, useState, useCallback } from 'react';
import AreaGredientChartY from './Usercomp/AreaGredientChartY';
import DailyTradeTable from './Usercomp/DailyTradeTable';
import DailyTradeDescription from './Usercomp/DailyTradeDescription';
import SmallCalendar from './Usercomp/SmallCalender';

import { useDispatch, useSelector } from 'react-redux';
import {
  useDailyJournalMutation,
  useDeleteNoteMutation,
  useSaveNoteMutation,
} from '../slices/zerodhaApiSlice';
// import "../glass.css"
import { setDailyjournal } from '../slices/dailyjournalSlice';
import moment from 'moment-timezone';
import MyEditor from './Usercomp/MyEditor';
import { useAssignStrategyMutation, useGetAllStrategyQuery } from '../slices/strategyApiSlice';
import { GlassButton, GlassInput, GlassModal } from '../glass';

const DailyJournalScreen = () => {
  moment.tz.setDefault('Asia/Kolkata');

  const { Title, Text } = Typography;
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const [showid, setShowid] = useState(0);
  const [api, contextHolder] = notification.useNotification();

  const { date } = useSelector((state) => state.date);
  const { dailyjournal } = useSelector((state) => state.dailyjournal);

  const [data, setData] = useState([]);
  const [modeldata, setModeldata] = useState({});
  const [content, setContent] = useState('');
  const [title, setTitle] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const pageSize = 5;

  const { data: strategiesResponse } = useGetAllStrategyQuery();
  const [selectedStrategy, setSelectedStrategy] = useState(null);

  const strategyOptions =
    strategiesResponse?.data?.map((s) => ({
      value: s.id,
      label: s.name,
    })) || [];

  const [assignStrategy] = useAssignStrategyMutation();

  const [dailyJournal, { isLoading: isJournalLoading }] =
    useDailyJournalMutation();

  const [saveNote, { isLoading: isSaveNoteLoading }] =
    useSaveNoteMutation();

  const [deleteNote] = useDeleteNoteMutation();

  const dispatch = useDispatch();

  // Fetch journal data
  const fetchJournal = useCallback(
    async (page = 1) => {
      try {
        const res = await dailyJournal({
          startDate: date.startDate,
          endDate: date.endDate,
          page,
          pageSize,
        }).unwrap();

        if (res?.data) {
          setData(res.data.results || []);
          setTotalRecords(res.data.totalCount || 0);
          dispatch(setDailyjournal(res.data));
        }
      } catch (err) {
        api.error({
          message:
            err?.data?.message ||
            err?.data?.error ||
            err?.error ||
            'Unable to fetch journal data',
        });
      }
    },
    [dailyJournal, date, dispatch, api]
  );

  useEffect(() => {
    fetchJournal(currentPage);
  }, [currentPage, fetchJournal]);

  // Sync modal content when selected journal entry changes
  useEffect(() => {
    if (modeldata) {
      setTitle(modeldata?.note?.title || '');
      setContent(modeldata?.note?.content || '');
    }
  }, [modeldata]);

  const showModal = (entry) => {
    setModeldata(entry || {});
    setSelectedStrategy(entry?.note?.strategy_id || null);
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      const trade_date = modeldata?._id;

      await saveNote({
        title,
        content,
        trade_date,
        strategy_id: selectedStrategy,
      }).unwrap();

      api.success({ message: 'Note Saved!' });

      resetModal();
      fetchJournal(currentPage);
    } catch (err) {
      api.error({
        message:
          err?.data?.message ||
          err?.data?.error ||
          err?.error ||
          'Unable to save note',
      });
    }
  };

  const handleCancel = () => {
    resetModal();
  };

  const resetModal = () => {
    setIsModalOpen(false);
    setModeldata({});
    setTitle('');
    setContent('');
    setSelectedStrategy(null);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDeleteNote = async () => {
    if (!modeldata?._id) return;

    try {
      await deleteNote(modeldata._id).unwrap();

      api.success({ message: 'Note deleted successfully' });

      setTitle('');
      setContent('');

      resetModal();
      fetchJournal(currentPage);
    } catch (err) {
      api.error({
        message:
          err?.data?.message ||
          err?.data?.error ||
          err?.error ||
          'Unable to delete note',
      });
    }
  };

  return (
    <div className="glass-scope daily-journal">
      {contextHolder}

      {/* Daily Journal glass-theme styles */}
      <style>
        {`
          .daily-journal {
            min-width: 0;
            color: var(--g-text);
          }

          .daily-journal__title.ant-typography {
            color: var(--g-text) !important;
            font-family: 'Sora', sans-serif !important;
            font-size: 20px !important;
            font-weight: 400 !important;
            margin-bottom: 0 !important;
          }

          .daily-journal .ant-card.card_hover {
            margin-bottom: 24px;
            transition: border-color 0.2s, box-shadow 0.2s;
          }

          .daily-journal .ant-card.card_hover:hover {
            border-color: rgba(208, 157, 76, 0.3) !important;
            box-shadow:
              inset 0 1px 0 var(--g-highlight),
              0 14px 30px rgba(208, 157, 76, 0.10),
              0 12px 32px rgba(0, 0, 0, 0.45) !important;
          }

          .daily-journal .ant-card-head-title {
            color: var(--g-text);
          }

          .daily-journal .ant-card-head-title .ant-typography {
            color: var(--g-text);
          }

          .daily-journal .ant-card-extra {
            display: flex;
            align-items: center;
            gap: 8px;
          }

          .daily-journal .ant-pagination {
            color: var(--g-text);
          }

          .daily-journal .ant-pagination .ant-pagination-item a {
            color: var(--g-text);
          }

          .daily-journal .ant-pagination .ant-pagination-item-active {
            background: var(--g-gold-soft) !important;
            border-color: var(--g-gold) !important;
          }

          .daily-journal .ant-pagination .ant-pagination-item-active a {
            color: var(--g-gold) !important;
          }

          .daily-journal .ant-empty-description {
            color: var(--g-muted);
          }

          @media (max-width: 768px) {
            .daily-journal__title.ant-typography {
              font-size: 18px !important;
            }

            .daily-journal .ant-card-body {
              padding: 14px;
            }
          }
        `}
      </style>

      {/* Heading */}
      <Title level={2} className="daily-journal__title">
        <ReadOutlined /> Daily Journal
      </Title>

      <Divider />

      <Row gutter={[16, 24]} style={{ marginBottom: '10px' }}>
{/* <Row gutter={[16, 24]}> */}
  <Col md={18} xs={24}>          {dailyjournal?.results?.length > 0 ? (
            dailyjournal.results.map((dat, index) => (
              <Card
                key={dat._id || index}
                bordered={false}
                className="card_hover"
                extra={
                  dat.note == null ? (
                    <Tooltip title="Add Note">
                      <Button
                        type="primary"
                        shape="circle"
                        onClick={() => showModal(dat)}
                      >
                        <FileAddOutlined />
                      </Button>
                    </Tooltip>
                  ) : (
                    <Tooltip title="View Note">
                      <Button
                        type="dashed"
                        shape="circle"
                        onClick={() => showModal(dat)}
                      >
                        <EyeOutlined />
                      </Button>
                    </Tooltip>
                  )
                }
                title={
                  <>
                    <Button
                      type="primary"
                      shape="circle"
                      onClick={() =>
                        setShowid(showid === index ? -1 : index)
                      }
                    >
                      {showid === index ? (
                        <DownOutlined />
                      ) : (
                        <RightOutlined />
                      )}
                    </Button>

                    <Text>
                      {' '}
                      {moment(dat._id).format('ddd, D MMM, YYYY')}{' '}
                      <Badge status="default" />
                    </Text>

                    <Text
                      type={
                        Number(
                          parseFloat(dat.runningPnlArray?.at(-1)?.pnl || 0)
                        ) >= 0
                          ? 'success'
                          : 'danger'
                      }
                    >
                      {' '}
                      Realised P&amp;L ₹{' '}
                      {isJournalLoading
                        ? '...'
                        : Number(
                            parseFloat(
                              dat.runningPnlArray?.at(-1)?.pnl || 0
                            )
                          ).toFixed(2)}
                    </Text>
                  </>
                }
                loading={isJournalLoading}
              >
                <Row gutter={[16, 24]} style={{ marginBottom: '10px' }}>
                  <Col md={8} xs={24}>
                    <AreaGredientChartY
                      datal={
                        isJournalLoading ? [] : dat.runningPnlArray || []
                      }
                    />
                  </Col>

                  <Col md={16} xs={24}>
                    <DailyTradeDescription data={dat} />
                  </Col>
                </Row>

                {showid === index && (
                  <Row style={{ paddingTop: '10px' }}>
                    <DailyTradeTable data={dat.trades} />
                  </Row>
                )}
              </Card>
            ))
          ) : (
            <Card bordered={false} className="card_hover">
              <Empty />
            </Card>
          )}

          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={totalRecords}
            onChange={handlePageChange}
            style={{
              textAlign: 'center',
              marginTop: '20px',
            }}
          />
        </Col>

        <Col md={6} xs={24}>
          <SmallCalendar
            onDateChange={(selectedDate) => {
              const startDate = moment(selectedDate)
                .startOf('day')
                .toISOString();

              const endDate = moment(selectedDate)
                .endOf('day')
                .toISOString();

              // Keep your existing date-range update mechanism here.
              // The original code used dispatch(setData(...)), but setData
              // was not imported in this component.
              fetchJournal(1);
            }}
          />
        </Col>
      </Row>

      {/* Journal note modal
      <Modal
        className="daily-journal-modal"
        title={
          <>
            <Text>
              {modeldata?._id
                ? moment(modeldata._id).format('ddd, D MMM, YYYY')
                : 'Daily Journal'}{' '}
              <Badge status="default" />
            </Text>

            <Text
              type={
                Number(
                  parseFloat(
                    modeldata?.runningPnlArray?.at(-1)?.pnl || 0
                  )
                ) >= 0
                  ? 'success'
                  : 'danger'
              }
            >
              {' '}
              Realised P&amp;L ₹{' '}
              {Number(
                parseFloat(modeldata?.runningPnlArray?.at(-1)?.pnl || 0)
              ).toFixed(2)}
            </Text>
          </>
        }
        width={1000}
        open={isModalOpen}
        onOk={handleOk}
        confirmLoading={isSaveNoteLoading}
        onCancel={handleCancel}
      >
        <Row gutter={[16, 24]} style={{ marginBottom: '10px' }}>
          <Col md={8} xs={24}>
            <AreaGredientChartY
              datal={modeldata?.runningPnlArray || []}
            />
          </Col>

          <Col md={16} xs={24}>
            <DailyTradeDescription data={modeldata} />
          </Col>
        </Row>

        <Row justify="end" style={{ marginBottom: 10 }}>
          <Col xs={12} sm={8} md={8} lg={6} xl={4}>
            <Button danger block onClick={handleDeleteNote}>
              Delete Note
            </Button>
          </Col>
        </Row>

        <Row>
          <Input
            placeholder="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            style={{ marginBottom: '10px' }}
          />

          {isModalOpen && (
            <MyEditor
              setContent={setContent}
              initialContent={content}
            />
          )}
        </Row>
      </Modal> */}


      <GlassModal
  open={isModalOpen}
  onClose={resetModal}
  width={1000}
  title={`${modeldata?._id ? moment(modeldata._id).format('ddd, D MMM, YYYY') : 'Daily Journal'}  ·  Realised P&L ₹ ${
    isJournalLoading
      ? '0.00'
      : Number(
          parseFloat(modeldata?.runningPnlArray?.at(-1)?.pnl || 0)
        ).toFixed(2)
  }`}
  footer={
    <>
      <GlassButton onClick={resetModal}>
        Cancel
      </GlassButton>

      <GlassButton
        variant="primary"
        disabled={isSaveNoteLoading}
        onClick={handleOk}
      >
        {isSaveNoteLoading ? 'Saving…' : 'Save note'}
      </GlassButton>
    </>
  }
>
  <div className="glass-grid glass-grid--modal">
    <AreaGredientChartY
      datal={isJournalLoading ? [] : modeldata?.runningPnlArray || []}
    />

    <DailyTradeDescription data={modeldata} />
  </div>

  <div
    style={{
      display: 'flex',
      justifyContent: 'flex-end',
      margin: '12px 0',
    }}
  >
    <GlassButton
      variant="danger"
      onClick={handleDeleteNote}
    >
      Delete note
    </GlassButton>
  </div>

  <GlassInput
    placeholder="Title"
    value={title}
    onChange={(e) => setTitle(e.target.value)}
  />

  <div style={{ marginTop: 10 }}>
    {isModalOpen && (
      <MyEditor
        setContent={setContent}
        initialContent={content}
      />
    )}
  </div>
</GlassModal>
    </div>
  );
};

export default DailyJournalScreen;